import React from 'react';
import { Stack } from 'stackflow';

const App = () => {
  return <Stack />;
};

export default App;
